import * as styles from "./ListSection.css";

type ListSectionProps = {
  letter: string;
};

export function ListSection({ letter }: ListSectionProps) {
  return (
    <div className={styles.section} data-addressbook-letter={letter}>
      {letter}
    </div>
  );
}
